import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendOTP, verifyOTP, setPassword } from '../../services/authService';

function Register() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [password, setPasswordValue] = useState('');
  const [message, setMessage] = useState({ type: '', text: '' });
  const navigate = useNavigate();

  const handleSendOTP = (e) => {
    e.preventDefault();
    sendOTP(email)
      .then(() => {
        setOtpSent(true);
        setMessage({ type: 'success', text: 'OTP sent to your email.' });
      })
      .catch(() => {
        setMessage({ type: 'error', text: 'Error sending OTP.' });
      });
  };

  const handleVerifyOTP = (e) => {
    e.preventDefault();
    verifyOTP(email, code)
      .then(() => {
        setOtpVerified(true);
        setMessage({ type: 'success', text: 'OTP Verified. Please set your password.' });
      })
      .catch((error) => {
        setMessage({
          type: 'error',
          text: error.response?.data?.error || 'Invalid OTP.',
        });
      });
  };

  const handleSetPassword = (e) => {
    e.preventDefault();
    setPassword(email, password)
      .then(() => {
        setMessage({ type: 'success', text: 'Registration successful. You can now log in.' });
        navigate('/login');
      })
      .catch((error) => {
        setMessage({
          type: 'error',
          text: error.response?.data?.error || 'Error setting password.',
        });
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="p-8 bg-white rounded shadow-lg w-96">
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-700">Register</h2>
        {message.text && (
          <div
            className={`mb-4 px-4 py-2 text-white rounded ${
              message.type === 'success' ? 'bg-green-500' : 'bg-red-500'
            }`}
          >
            {message.text}
          </div>
        )}
        {!otpSent && (
          <form onSubmit={handleSendOTP}>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="w-full px-4 py-2 font-bold text-white bg-blue-600 rounded hover:bg-blue-700"
            >
              Send OTP
            </button>
          </form>
        )}
        {otpSent && !otpVerified && (
          <form onSubmit={handleVerifyOTP}>
            <input
              type="text"
              placeholder="Enter OTP"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="w-full px-4 py-2 font-bold text-white bg-blue-600 rounded hover:bg-blue-700"
            >
              Verify OTP
            </button>
          </form>
        )}
        {otpVerified && (
          <form onSubmit={handleSetPassword}>
            <input
              type="password"
              placeholder="Set Password"
              value={password}
              onChange={(e) => setPasswordValue(e.target.value)}
              required
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="w-full px-4 py-2 font-bold text-white bg-green-600 rounded hover:bg-green-700"
            >
              Complete Registration
            </button>
          </form>
        )}
        <div className="mt-4 text-center">
          Already have an account?{' '}
          <a href="/login" className="text-blue-600 hover:underline">
            Login
          </a>
        </div>
      </div>
    </div>
  );
}

export default Register;
